// src/utils/utils_tierPicker.ts
//
// Fait patienter un openBuyXxx() (utils_*Purchase.ts) pendant que l'utilisateur choisit
// un palier dans TierPickerModal (montée une fois à la racine de l'app, comme
// QuotaPurchaseModal). Redux ne porte que ce qu'il faut AFFICHER (label + paliers,
// sérialisables) ; la Promise elle-même — donc la fonction à rappeler — vit ici, dans
// une variable de module : c'est la seule façon de rendre `await pickTier(...)`
// possible depuis une fonction utilitaire sans component React autour.

import { store            }  from "../store/store";
import { openTierPicker   ,
         closeTierPicker  }  from "../store/tierPickerManagment/actions";
import { PurchaseTier     }  from "../store/tierPickerManagment/types";

export type { PurchaseTier };

let pendingResolve: ((tier: PurchaseTier | null) => void) | null = null;

/**
 * @returns le palier choisi, ou null si l'utilisateur a annulé.
 */
export function pickTier(label: string, tiers: PurchaseTier[]): Promise<PurchaseTier | null> {
  return new Promise((resolve) => {
    // Un choix resterait indéfiniment en attente si un second appel écrasait le premier
    // sans jamais le résoudre — ne devrait pas arriver (un seul achat à la fois), mais
    // évite une fuite silencieuse si ça arrivait quand même.
    pendingResolve?.(null);

    pendingResolve = resolve;
    store.dispatch(openTierPicker(label, tiers));
  });
}

/** Appelé uniquement par TierPickerModal — jamais directement par un openBuyXxx(). */
export function resolveTierPick(tier: PurchaseTier | null): void {
  store.dispatch(closeTierPicker());

  const resolve = pendingResolve;
  pendingResolve = null;
  resolve?.(tier);
}
